import { buildClientSchema, TypeInfo, visit, visitWithTypeInfo, Kind, isListType, isNonNullType, isScalarType } from 'graphql';
import { isNode } from 'graphql/language/ast';
import { pipe, map } from 'wonka';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function makeIsAstNodeOfKind(kind) {
  return function (maybeNodeOrArray) {
    if (!isNode(maybeNodeOrArray)) {
      return false;
    }

    return maybeNodeOrArray.kind === kind;
  };
}

var isFieldNode = /*#__PURE__*/makeIsAstNodeOfKind(Kind.FIELD);
var isFragmentDefinition = /*#__PURE__*/makeIsAstNodeOfKind(Kind.FRAGMENT_DEFINITION);

function mapScalar(data, path, map) {
  if (data == null) {
    return data;
  }

  var newData = _extends({}, data);

  var newSubData = newData;

  for (var index = 0; index < path.length - 1; index += 1) {
    var segment = path[index];

    if (Array.isArray(newSubData[segment])) {
      var _ret = function () {
        var subPath = path.slice(index + 1);
        newSubData[segment] = newSubData[segment].map(function (subData) {
          return mapScalar(subData, subPath, map);
        });
        return {
          v: newData
        };
      }();

      if (typeof _ret === "object") return _ret.v;
    } else if (newSubData[segment] === null) {
      return newData;
    } else {
      newSubData[segment] = _extends({}, newSubData[segment]);
    }

    newSubData = newSubData[segment];
  }

  var finalSegment = path[path.length - 1];

  if (Array.isArray(newSubData[finalSegment])) {
    newSubData[finalSegment] = newSubData[finalSegment].map(map);
  } else if (newSubData[finalSegment] != null) {
    newSubData[finalSegment] = map(newSubData[finalSegment]);
  }

  return newData;
}

function unpackTypeInner(type) {
  if (isListType(type) || isNonNullType(type)) {
    return unpackTypeInner(type.ofType);
  }

  if (isScalarType(type)) {
    return type;
  }

  return;
}

function unpackType(type) {
  return unpackTypeInner(type);
}

function scalarExchange(_ref) {
  var schema = _ref.schema,
      scalars = _ref.scalars;
  var clientSchema = buildClientSchema(schema);
  var typeInfoInstance = new TypeInfo(clientSchema);

  var makeVisitor = function makeVisitor(nodesOfInterest) {
    return visitWithTypeInfo(typeInfoInstance, {
      Field: function Field(_node, _key, _parent, astPath, anchestorAstNodes) {
        var fieldType = typeInfoInstance.getType();

        if (fieldType == null) {
          return;
        }

        var scalarType = unpackType(fieldType);

        if (scalarType == null) {
          return;
        }

        var name = scalarType.name;

        if (scalars[name] == null) {
          return;
        }

        var currentAstNode = anchestorAstNodes[0];
        var path = [];
        var fragmentName;

        for (var _iterator = _createForOfIteratorHelperLoose(astPath), _step; !(_step = _iterator()).done;) {
          var segment = _step.value;
          // @ts-expect-error
          currentAstNode = currentAstNode[segment];

          if (isFieldNode(currentAstNode)) {
            var fieldNode = currentAstNode;

            if (fieldNode.alias) {
              path.push(fieldNode.alias.value);
            } else {
              path.push(fieldNode.name.value);
            }
          } else if (isFragmentDefinition(currentAstNode)) {
            fragmentName = currentAstNode.name.value;
          }
        }

        nodesOfInterest.push({
          fragmentName: fragmentName,
          kind: 'Scalar',
          name: name,
          path: path
        });
      },
      FragmentSpread: function FragmentSpread(node, _key, _parent, astPath, anchestorAstNodes) {
        var currentAstNode = anchestorAstNodes[0];
        var path = [];

        for (var _iterator2 = _createForOfIteratorHelperLoose(astPath), _step2; !(_step2 = _iterator2()).done;) {
          var segment = _step2.value;
          // @ts-expect-error
          currentAstNode = currentAstNode[segment];

          if (isFieldNode(currentAstNode)) {
            var fieldNode = currentAstNode;

            if (fieldNode.alias) {
              path.push(fieldNode.alias.value);
            } else {
              path.push(fieldNode.name.value);
            }
          }
        }

        nodesOfInterest.push({
          kind: 'FragmentSpread',
          name: node.name.value,
          path: path
        });
      }
    });
  };

  return function (_ref2) {
    var forward = _ref2.forward;
    return function (operations$) {
      var operationResult$ = forward(operations$);
      return pipe(operationResult$, map(function (args) {
        if (args.data == null) {
          return args;
        }

        var nodesOfInterest = [];
        visit(args.operation.query, makeVisitor(nodesOfInterest));

        if (nodesOfInterest.length === 0) {
          return args;
        }

        var spreadFragmentsInQuery = {};
        var scalarsInQuery = [];

        for (var _i = 0, _nodesOfInterest = nodesOfInterest; _i < _nodesOfInterest.length; _i++) {
          var nodeOfInterest = _nodesOfInterest[_i];
          var kind = nodeOfInterest.kind;

          if (kind === 'Scalar') {
            scalarsInQuery.push(nodeOfInterest);
          } else {
            var _spreadFragmentsInQue;

            var name = nodeOfInterest.name;
            spreadFragmentsInQuery[name] = (_spreadFragmentsInQue = spreadFragmentsInQuery[name]) != null ? _spreadFragmentsInQue : [];
            spreadFragmentsInQuery[name].push(nodeOfInterest);
          }
        }

        for (var _i2 = 0, _scalarsInQuery = scalarsInQuery; _i2 < _scalarsInQuery.length; _i2++) {
          var _scalarsInQuery$_i = _scalarsInQuery[_i2],
              fragmentName = _scalarsInQuery$_i.fragmentName,
              _name = _scalarsInQuery$_i.name,
              path = _scalarsInQuery$_i.path;

          if (fragmentName && spreadFragmentsInQuery[fragmentName]) {
            for (var _iterator3 = _createForOfIteratorHelperLoose(spreadFragmentsInQuery[fragmentName]), _step3; !(_step3 = _iterator3()).done;) {
              var pathToFragment = _step3.value.path;
              args.data = mapScalar(args.data, [].concat(pathToFragment, path), scalars[_name]);
            }
          } else {
            args.data = mapScalar(args.data, path, scalars[_name]);
          }
        }

        return args;
      }));
    };
  };
}

export default scalarExchange;
//# sourceMappingURL=urql-custom-scalars-exchange.esm.js.map
